module.exports = __webpack_public_path__ + "static/media/harrys.bd0b7e98.svg";